import { 
  LayoutDashboard, 
  Store, 
  CircleDollarSign, 
  ShoppingCart,
  Package,
  Settings,
  LogOut,
  CreditCard,
  Bell,
  ActivityIcon
} from "lucide-react";
import { CSSProperties } from "react";

export type MenuItem = {
  icon: any; // Replace with appropriate type if available
  label: string;
  path: string;
  className?: string;
  style?: CSSProperties;
};

export const getDashboardMenuItems = (): MenuItem[] => {
  return [
    {
      icon: LayoutDashboard,
      label: "Dashboard",
      path: "/florist-dashboard",
    },
    {
      icon: ActivityIcon,
      label: "Live Dashboard",
      path: "/florist-dashboard/live",
    },
    {
      icon: Store,
      label: "View Store",
      path: "/florist", // This path will be modified in DashboardNavigation with the actual storeId
    },
    {
      icon: CircleDollarSign,
      label: "Analytics",
      path: "/florist-dashboard/analytics",
    },
    {
      icon: ShoppingCart,
      label: "Orders",
      path: "/florist-dashboard/orders",
    },
    {
      icon: Package,
      label: "Products",
      path: "/florist-dashboard/products",
    },
    {
      icon: CreditCard,
      label: "Payment Settings",
      path: "/payment-settings",
    },
    {
      icon: Bell,
      label: "Notifications",
      path: "/florist-dashboard/notifications",
    },
    {
      icon: Settings,
      label: "Settings",
      path: "/florist-dashboard/settings",
    },
    {
      icon: LogOut,
      label: "Sign Out",
      path: "/",
      className: "mt-10",
    },
  ];
};